export const toAssignmentManagementPayload = (values, assignment) => ({
  ...assignment,
  manager: {
    id: values.manager.value
  },
  delegate: values.delegate ? { id: values.delegate.value } : null
})
